var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    xmlns: "http://www.w3.org/2000/svg",
    height: 33,
    id: "screenshot-3fae1a31-d97a-8093-8007-3da11513148d",
    viewBox: "0 0 35 33",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-3fae1a31-d97a-8093-8007-3da11513148d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-3fae1a31-d97a-8093-8007-3da11513148d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.00000000000023,
    height: 33,
    className: "frame-background",
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "rgb(96, 95, 95)",
      fillOpacity: 0
    },
    ry: 0,
    rx: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-3fae1a31-d97a-8093-8007-3da11513148e",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-3fae1a31-d97a-8093-8007-3da11513148f",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-3fae1a31-d97a-8093-8007-3da11513148f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.00000000000023,
    height: 33,
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-3fae1a31-d97a-8093-8007-3da115131490"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape-3fae1a31-d97a-8093-8007-3da115131492"
  }, /*#__PURE__*/React.createElement("style", null, "#shape-3fae1a31-d97a-8093-8007-3da11513148e{ .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      } }"))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-3fae1a31-d97a-8093-8007-3da115131491",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shape-3fae1a31-d97a-8093-8007-3da115131494"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-3fae1a31-d97a-8093-8007-3da115131494"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.305419921875,11.95654296875L23.26708984375,19.88763427734375L21.78564453125,20.7445068359375L23.625,13.6005859375L10.5498046875,21.1131591796875L9.913330078125,20.126708984375L22.988525390625,12.6141357421875L15.402099609375,10.8804931640625L16.883544921875,10.033447265625L25.305419921875,11.95654296875Z",
    className: "cls-1"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shape-3fae1a31-d97a-8093-8007-3da115131495"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-3fae1a31-d97a-8093-8007-3da115131495"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.50000000000034,
    cy: 16.500000000000057,
    rx: 17.3707386363634,
    ry: 16.380434782608802,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "cls-2"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseArrow);
export default __webpack_public_path__ + "static/media/course-arrow.dc8285c11edd30f7d5b6b787d84d726d.svg";
export { ForwardRef as ReactComponent };